import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import { CallMerge } from "@mui/icons-material";

// ============================================================================
// Types
// ============================================================================

export interface ConfirmMergeDialogProps {
	open: boolean;
	jobCount: number;
	onConfirm: () => void;
	onCancel: () => void;
}

// ============================================================================
// Component
// ============================================================================

export function ConfirmMergeDialog({ open, jobCount, onConfirm, onCancel }: ConfirmMergeDialogProps) {
	return (
		<Dialog
			open={open}
			onClose={onCancel}
			aria-labelledby="confirm-merge-dialog-title"
			aria-describedby="confirm-merge-dialog-description"
		>
			<DialogTitle id="confirm-merge-dialog-title">Merge Jobs</DialogTitle>
			<DialogContent>
				<DialogContentText id="confirm-merge-dialog-description">
					Are you sure you want to merge {jobCount} jobs into one? This cannot be undone.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onCancel} data-testid="confirm-merge-dialog-cancel">
					Cancel
				</Button>
				<Button
					onClick={onConfirm}
					color="primary"
					variant="contained"
					startIcon={<CallMerge />}
					autoFocus
					data-testid="confirm-merge-dialog-confirm"
				>
					Merge
				</Button>
			</DialogActions>
		</Dialog>
	);
}
